import Loader from "./Loader";
export { default as WiggleLoader } from "./WiggleLoader";

export default Loader;
